import {
	fetchPPPTypesOvmQuery,
	useAxiosInstance,
	usePoMutation,
} from '@gov-nx/api';

interface PppTypesOvmQueryProps {
	typPppKod: string;
}

export const usePPPTypesOvmQuery = ({ typPppKod }: PppTypesOvmQueryProps) => {
	const { axiosInstance } = useAxiosInstance();

	const mutation = usePoMutation({
		mutationFn: (text: string) =>
			fetchPPPTypesOvmQuery(axiosInstance, { typPppKod, text }),
	});

	return {
		searchCallback: async (input: string) => {
			const result = await mutation.mutateAsync(input);
			return result.seznam ?? [];
		},
	};
};
